import type { V2Call } from "./action";

/**
 * Converts the SDK's deliberately small private-call vocabulary into the production
 * contract ABI. Contract-side canonicalization performs the final value and
 * denomination validation before a proof can authorize the batch.
 */
export const normalizePrivateV2Call = (value: unknown): V2Call => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    throw new Error("Invalid private batch call");
  }
  const call = value as Record<string, any>;
  if (call.wasm?.execute) {
    const execute = call.wasm.execute;
    if (
      typeof execute.contract_addr !== "string" ||
      typeof execute.msg !== "string" ||
      !Array.isArray(execute.funds)
    ) {
      throw new Error("Invalid private Wasm call");
    }
    return {
      wasm_execute: {
        contract_addr: execute.contract_addr,
        msg: execute.msg,
        funds: execute.funds,
      },
    };
  }
  if (call.bank?.send) {
    const send = call.bank.send;
    if (typeof send.to_address !== "string" || !Array.isArray(send.amount)) {
      throw new Error("Invalid private bank call");
    }
    return { bank_send: { to_address: send.to_address, amount: send.amount } };
  }
  if (call.thorchain?.deposit) {
    const deposit = call.thorchain.deposit;
    if (
      typeof deposit.denom !== "string" ||
      typeof deposit.amount !== "string" ||
      typeof deposit.memo !== "string" ||
      !deposit.asset ||
      typeof deposit.asset !== "object" ||
      typeof deposit.asset.chain !== "string" ||
      typeof deposit.asset.symbol !== "string" ||
      typeof deposit.asset.ticker !== "string" ||
      typeof deposit.asset.secured !== "boolean"
    ) {
      throw new Error("Invalid private THORChain deposit call");
    }
    return {
      thorchain_deposit: {
        denom: deposit.denom,
        asset: deposit.asset,
        amount: deposit.amount,
        memo: deposit.memo,
      },
    };
  }
  throw new Error("Unsupported private batch call");
};
